export default "__VITE_ASSET__DTe$QHwM__"